/** @module builtins/String */

/* eslint-disable no-extend-native */

/**
 * To Title Case 2.1 – http://individed.com/code/to-title-case/.
 * Copyright © 2008–2013 David Gouch. Licensed under the MIT License.
 * Extend the String class with a function that can return a title case representation of the string.
 * @returns {String} The title case string.
 */
Object.defineProperty(String.prototype, 'toTitleCase', {
    value: function () {
        const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

        return this.replaceAll(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, (match, index, title) => {
            if (
                index > 0 &&
                index + match.length !== title.length &&
                match.search(smallWords) > -1 &&
                title.charAt(index - 2) !== ':' &&
                (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
                title.charAt(index - 1).search(/[^\s-]/) < 0
            ) {
                return match.toLowerCase();
            }

            if (match.substr(1).search(/[A-Z]|\../) > -1) {
                return match;
            }

            return match.charAt(0).toUpperCase() + match.substr(1);
        });
    },
});

/**
 * Return the string in reverse order.
 * @returns {String}
 */
Object.defineProperty(String.prototype, 'toReversed', {
    value: function () {
        const arr = [...this];
        arr.reverse();
        return arr.join('');
    },
});

/**
 * Return the string in reverse order.
 * @deprecated Use String#toReversed instead.
 * @returns {String}
 */
Object.defineProperty(String.prototype, 'reverse', {
    value: String.prototype.toReversed,
});

/* eslint-enable no-extend-native */
